var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 3.95833C0.75 1.55189 0.775767 0.75 3.95833 0.75C7.1409 0.75 7.16667 1.55189 7.16667 3.95833C7.16667 6.36478 7.17682 7.16667 3.95833 7.16667C0.73985 7.16667 0.75 6.36478 0.75 3.95833Z",
    stroke: "#2BA7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 3.95833C10.8335 1.55189 10.8593 0.75 14.0418 0.75C17.2244 0.75 17.2502 1.55189 17.2502 3.95833C17.2502 6.36478 17.2603 7.16667 14.0418 7.16667C10.8233 7.16667 10.8335 6.36478 10.8335 3.95833Z",
    stroke: "#2BA7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 14.0418C0.75 11.6354 0.775767 10.8335 3.95833 10.8335C7.1409 10.8335 7.16667 11.6354 7.16667 14.0418C7.16667 16.4483 7.17682 17.2502 3.95833 17.2502C0.73985 17.2502 0.75 16.4483 0.75 14.0418Z",
    stroke: "#2BA7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 14.0418C10.8335 11.6354 10.8593 10.8335 14.0418 10.8335C17.2244 10.8335 17.2502 11.6354 17.2502 14.0418C17.2502 16.4483 17.2603 17.2502 14.0418 17.2502C10.8233 17.2502 10.8335 16.4483 10.8335 14.0418Z",
    stroke: "#2BA7CA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWadge);
export default __webpack_public_path__ + "static/media/Wadge.f700083501e0ebd10802314acd6367bc.svg";
export { ForwardRef as ReactComponent };